import PlansComparison from "../PlansComparison";
import TeacherList from "../Teachers";
import TextBanner from "../GoldenTextBanner";
import ThumbnailList from "../Thumbnails";
import DemoVideoList from "../DemoVideo";
import CourseVideoBanner from "./CourseVideoBanner";
import CourseAdvantage from "./CourseAdvantage";
import { ICourseWidget } from "./interfaces";
import ImageBanner from "./ImageBanner";
import Accordion from "../Accordion/Accordion";
import { IAccordionItem } from "../Accordion/interfaces";
import CourseListFilter from "./CourseListFilter";
import CourseCardV2List from "./CourseCardV2List";


const CourseWidget = (props: ICourseWidget) => {
  const { category, items } = props;

  try{
    return <div className={`${props.className ?? ""}`}>
      {
        items.map((item, index) => {
          const {
            nodeName,
            props: data
          } = item;

          switch(nodeName.toLowerCase()){
            // case "image-banner":
            //   return <ImageBanner key={index.toString()} data={data}/>
            // case "demo-videos":
            //   return <DemoVideoList key={index.toString()} data={data} />
            case "text-banner":
              return <TextBanner key={index.toString()}  text={data.text} url={data.href} />
            case "video-banner":
              return <CourseVideoBanner key={index.toString()}  item={data} />
            case "thumbnail-list":
              return <ThumbnailList key={index.toString()} title={data.title} className={data.className} items={data.items} />
            // case "teacher-list":
            //   return <TeacherList key={index.toString()} category={category} title={data.title} className={data.className} items={data.items} /> 
            // case "advantage":
            //   return <CourseAdvantage key={index.toString()} data={data}/>    
            case "plans-comparison":
              return <section key={index.toString()} >
                <h3>{data.title}</h3>
                <PlansComparison className={"bg-[#FFE8A8] dark:!bg-[#FFE8A8] dark:text-black"} items={data.items}/>
              </section>  
            case "course-list":
              return <section id="courses" key={index.toString()}>
                <h3>{data.title}</h3>
                {/* <CourseCardV2List category={category} items={data.items.filter((item:any)=>item.assortment_id)}/>  */}
                <CourseListFilter category={category} data={data} />
              </section>  
            case "syllabus":
              const items = data.items.map((item: IAccordionItem) => {
                return {
                  ...item, 
                  list: item.list?.map((subItem) => {
                    return {
                      title: subItem,
                      icon: "PlayIcon"
                    }
                  }
                  )
                };
              })
              return <section id="syllabus" key={index.toString()}>
                {/* exisitng component has text center and different title */}
                <h3 className="text-left">{data.title}</h3>
                <Accordion parentClassName="course-syllabus" items={items}/>
              </section>        
            default:
              return null;     
          }   
        })
      }
    </div>
  }catch(e){
    return <></>
  }
};

export default CourseWidget;